var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGpsLost = function SvgGpsLost(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6277_126294)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8.97827,
    r: 5.76733,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 20.7055C7.31671 18.4221 5.31269 16.3011 3.98802 14.3424C2.66267 12.3844 2 10.5721 2 8.90539C2 6.40537 2.80434 4.41369 4.41302 2.93034C6.02103 1.44699 7.88338 0.705322 10.0001 0.705322C12.1167 0.705322 13.9794 1.44699 15.5881 2.93034C17.1961 4.41369 18.0001 6.40537 18.0001 8.90539C18.0001 10.5721 17.3375 12.3844 16.0121 14.3424C14.6874 16.3011 12.6834 18.4221 10.0001 20.7055Z",
    fill: "#EA5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21973 6.198C7.36621 6.05151 7.55811 5.97827 7.75 5.97827C7.94189 5.97827 8.13379 6.05151 8.28027 6.198L10 7.91772L11.7197 6.198C12.0127 5.90503 12.4873 5.90503 12.7803 6.198C13.0732 6.49097 13.0732 6.96558 12.7803 7.25854L11.0605 8.97827L12.7803 10.698C13.0732 10.991 13.0732 11.4656 12.7803 11.7585C12.6338 11.905 12.4419 11.9783 12.25 11.9783C12.0581 11.9783 11.8662 11.905 11.7197 11.7585L10 10.0388L8.28027 11.7585C8.13379 11.905 7.94189 11.9783 7.75 11.9783C7.55811 11.9783 7.36621 11.905 7.21973 11.7585C6.92676 11.4656 6.92676 10.991 7.21973 10.698L8.93945 8.97827L7.21973 7.25854C6.92676 6.96558 6.92676 6.49097 7.21973 6.198Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6277_126294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.705322)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGpsLost);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "gps-lost.b6ed2ae71ae5545f8b11cfda0737ce87.svg";